import topNavData from '../../data/topNav/topNav.json';
import type { TopNavData } from './types';

/**
 * Returns top-nav menu data for the main nav. Replaces Gatsby useStaticQuery.
 */
export default function useTopNavData(): { nodes: TopNavData } {
  const nodes = Array.isArray(topNavData) ? (topNavData as TopNavData) : [];
  return { nodes };
}
